// extracted by mini-css-extract-plugin
module.exports = {"otpInput":"otpInput_otpInput___3HAg","otpBox":"otpInput_otpBox__1mYre"};